import { FormattedMessage } from 'react-intl';
import { Box, Flex, Text } from '@theme-ui/components';
import { css } from '@emotion/react';

import Checkmark from '@app/components/Checkmark';
import useLocaleWithFallback from '@app/hooks/useLocaleWithFallback';
import colors from '@app/styles/theme/colors';
import { rem } from '@app/styles/theme/layout';

import type { PricingPage_content_pricing_pages_layout_item_pricing_pages_multi_layout_products_products_id as DirectusProduct } from '../../__generated__/PricingPage';
import { isJPHardware } from '../../helpers';
import type { PricingPageShopProduct_magento2_products_items_Magento2_BundleProduct as BundleMagentoProduct } from '../../hook/__generated__/PricingPageShopProduct';
import AddToCartButton from '../AddToCartButton/AddToCartButton';
import Price from '../Price';
import messages from '../ProductLayout/ProductLayout.messages';
import { Content, Picture, Title, Wrapper } from './styles';

interface ProductTileProps {
  directusProduct: DirectusProduct;
  magentoProduct: BundleMagentoProduct;
}

const BundleProductTile = ({
  directusProduct,
  magentoProduct,
}: ProductTileProps) => {
  const { findTranslationByKeyWithFallback } = useLocaleWithFallback();

  const { image, priceRange } = magentoProduct;

  const { title, translations } = directusProduct;
  const content = findTranslationByKeyWithFallback({
    translations,
    key: 'multiproduct_layout_content',
  });

  return (
    <Wrapper>
      <Picture
        data-testid="bundle-product-tile-image"
        src={image?.url ?? undefined}
        alt={image?.label ?? undefined}
      />
      <Title data-testid="bundle-product-tile-title" as="h3">
        {title}
      </Title>

      {content && <Content dangerouslySetInnerHTML={{ __html: content }} />}

      <Box py={10} sx={{ flexGrow: 1 }}>
        <Price price={priceRange} />
      </Box>

      <AddToCartButton product={magentoProduct} />

      {isJPHardware(magentoProduct) && (
        <Flex py={3}>
          <Checkmark
            color="white"
            css={css`
              display: flex;
              flex: 1;
              min-width: 24px;
              height: 24px;
              background-color: ${colors.acidGreen};
              border-radius: 99999px;
              margin-right: 12px;
              &:after {
                top: 3px;
                left: 7px;
              }
            `}
          />
          <Text
            sx={{ fontWeight: '500', fontSize: rem(12), lineHeight: '1.6' }}
          >
            <FormattedMessage {...messages.mediaIntegrtion} />
          </Text>
        </Flex>
      )}
    </Wrapper>
  );
};

export default BundleProductTile;
